<ng-container *ngIf="card">
  <div class="card card--custom" [ngClass]="{ 'card--custom--large': isLarge }">
    <a [airLink]="card.link[0]" [userEventSource]="userEventSource" [userEventLabel]="card.title" [userEventObject]="userEventObject">
      <div class="card__image">
        <figure>
          <air-focal-image [image]="card.image" [isCropped]="true"></air-focal-image>
        </figure>
      </div>

      <div class="card__stickers" *ngIf="card.points">
        <air-miles-sticker [points]="card.points" [size]="isLarge ? 'md' : undefined"></air-miles-sticker>
      </div>
      <div class="card__text">
        <h4 *ngIf="card.title" class="card__title">{{ card.title }}</h4>
      </div>
    </a>
  </div>
</ng-container>
